import { shallowEqual, sum } from '@mnd-frontend/utils';
import { memo } from 'react';
import { withComponentsContext } from '../../context';
import { max } from '../../utils';
import TooltipHeader from './TooltipHeader';
import TooltipItem from './TooltipItem';

const updateOnlyIfShown = (prev: any, props: any) => !props.show || shallowEqual(prev, props);

const TooltipBody = ({ dataPoint, dataSeries, totalText }: any) => {
  const getValue = (mapping: any) => Number(dataPoint[mapping.dataKey]) || 0;
  const precision = max(dataSeries, mapping => mapping.precision);

  return (
    <>
      <TooltipHeader
        totalText={totalText}
        name={dataPoint?.name || ''}
        value={sum(dataSeries, getValue) || 0}
        precision={precision as BigIntToLocaleStringOptions['maximumFractionDigits']}
      />
      {dataSeries
        .filter((s: any) => (s.hiddenOnZero ? getValue(s) > 0 : true))
        .map(({ id, ...mapping }: any) => (
          <TooltipItem key={id} value={getValue(mapping)} precision={precision} {...mapping} />
        ))}
    </>
  );
};

export default memo(withComponentsContext(TooltipBody, 'TooltipBody'), updateOnlyIfShown as any);
